import React from 'react';
import { renderComponent } from 'utils/commonUtils';
import FolderList from './FolderList';

const Folders = () => {
  return renderComponent(<FolderList />);
};

export default Folders;
